import Contact from './contact-page'
export default Contact
